import React from "react";
import moment from "moment";
import Icon from "../Icon";
import styles from "./LicenseExtension.module.scss";

const formatDate = (date) => moment(date).format("MMM D, YYYY");

/**
 * Feed body for a LICENSE_EXTENDED event: the expiry the subscription now
 * runs to, what it was before, the device it applies to and the operator's
 * note. `details` is the parsed event body (see helpers/licenseEvents.js).
 */
export default function LicenseExtension({ details }) {
  const { previous_expiry, new_expiry, serial_number, note } = details;
  const meta = [
    previous_expiry ? `Previously ${formatDate(previous_expiry)}` : null,
    serial_number ? `device ${serial_number}` : null,
  ].filter(Boolean);

  return (
    <>
      <div className={styles.wrap}>
        <div className={styles.icon}>
          <Icon name="event_available" size={22} />
        </div>
        <div className={styles.text}>
          <h3 className={styles.until}>Active until {formatDate(new_expiry)}</h3>
          {meta.length > 0 && (
            <p className={styles.previous}>{meta.join(" · ")}</p>
          )}
        </div>
      </div>
      {note && <p className={styles.note}>Note: {note}</p>}
    </>
  );
}
